import { useContext } from "react";

import SiteTitle from "./../../../utils/SiteTitle/SiteTitle";
import { authContext } from "./../../../context/Auth/AuthContext";

const LoginAuth = () => {
  const { username, setUsername, password, setPassword, handleSignIn } =
    useContext(authContext);

  return (
    <>
      <SiteTitle title="ورود به حساب کاربری" />

      <div className="account-pages my-5 pt-sm-5">
        <div className="container">
          <div className="row justify-content-center align-items-center">
            <div className="col-md-8 col-lg-6 col-xl-5">
              <div className="card overflow-hidden">
                <div className="bg-login text-center">
                  <div className="bg-login-overlay" />
                  <div className="position-relative">
                    <h5 className="text-white font-size-20">خوش آمدید!</h5>
                    <p className="text-white-50 mb-0">
                      جهت دسترسی به پنل مدیریت وارد شوید
                    </p>
                    <span className="logo logo-admin mt-4">
                      <img
                        src="/assets/images/logo-sm-dark.png"
                        alt=""
                        height={30}
                      />
                    </span>
                  </div>
                </div>
                <div className="card-body pt-5">
                  <div className="p-2">
                    <form className="form-group" onSubmit={handleSignIn}>
                      <div>
                        {/* Label */}
                        <label>نام کاربری</label>
                        {/* Input group */}
                        <div className="input-group input-group-merge">
                          <input
                            type="text"
                            id="username"
                            className="form-control"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            placeholder="نام کاربری خود را وارد کنید"
                          />
                        </div>
                      </div>
                      <div className="mt-1">
                        {/* Label */}
                        <label>رمزعبور</label>
                        {/* Input group */}
                        <div className="input-group input-group-merge">
                          <input
                            type="password"
                            id="password"
                            className="form-control"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="رمزعبور خود را وارد کنید"
                          />
                        </div>
                      </div>
                      {/* Submit */}
                      <button
                        type="submit"
                        className="btn btn-block btn-primary border-radius mt-4 mb-3"
                      >
                        ورود
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginAuth;
